<style src="./Event.scss" lang="scss" scoped></style>
<template>
  <section class="event">
    <content-header path="Resultado" />

    <form v-on:submit.prevent="searchSubmit">
      <section class="form-box row">
        <textbox
          v-model="filter.searchText"
          label="Buscar evento"
          placeholder="Digite o identificador do evento"
          class="col-9"
          :autofocus="true"
          :debounce="300"
          @debounce="loadList" />

        <button
          type="button"
          class="btn-primary col-3"
          @click="addNew">
          <icon-add />
          <span class="hide-md">Inserir Novo</span>
        </button>
      </section>
    </form>

    <section class="event-list">
      <div class="list-header">
        <div class="list-title">
          <span class="form-title">Lista de eventos</span>
        </div>
        <div class="paginator">
          <page-navigator
            :total-pages="paginator.totalPage"
            :per-page="paginator.perPage"
            v-model="paginator.actualPage" />
        </div>
      </div>

      <event-map
        :list="filteredList"
        @edit="edit"
        @refresh-list="loadList"/>
    </section>
    <right-side-panel ref="rspNewEvent" title="Novo Evento" :shortcut="['alt', 'n']">
      <new-event @refresh-list="refreshList" />
    </right-side-panel>
    <right-side-panel ref="rspEditEvent" title="Editar Evento">
      <edit-event
        :edit-data="editData"
        @refresh-list="refreshList" />
    </right-side-panel>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { Textbox, SourcePaginatorMixin, PageNavigator } from '@/components/primitives'
import { NewEvent, EventMap, EditEvent } from './components'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import GetEventList from '@/brain/event/ListEvent'
import {DebounceDirective} from '@/components/primitives/helpers/debounce/Debounce'

export default {
  name: 'Event',
  components: {
    ContentHeader,
    RightSidePanel,
    PageNavigator,
    NewEvent,
    EventMap,
    EditEvent,
    Textbox,
    IconAdd,
    IconEmpty
  },
  directives: {
    debounce: DebounceDirective
  },
  extends: {
    ...SourcePaginatorMixin
  },
  data () {
    return {
      filter: {
        searchText: ''
      },
      editData: {},
      filteredList: []
    }
  },
  watch: {
    paginator: {
      handler () {
        this.loadList()
      },
      deep: true
    }
  },
  mounted () {
    this.loadList()
  },
  methods: {
    searchSubmit () {},
    refreshList () {
      this.loadList()
    },
    loadList () {
      const params = this.buildQuery({ filters: this.filter })

      GetEventList({ params })
        .then((result) => {
          this.filteredList = result.list
          this.paginator.totalRegister = result.rows
          this.paginator.totalPage = Math.floor(result.rows / this.paginator.perPage)
        })
    },
    addNew () {
      this.$refs.rspNewEvent.showPanel()
    },
    cancelAddNew () {
    },
    addedSuccessful () {
      this.loadList()
    },
    edit (pId) {
      this.editData = {...this.filteredList[pId]}
      this.$refs.rspEditEvent.showPanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event/Event.vue